// Icon: mdi:clipboard
// Slug: Copy text to the clipboard
// Description: This action copies text to the clipboard using the Clipboard API.

import { action } from '@engine'

action({
  name: 'clipboard',
  apply: ({ error }, text: string, isBase64 = false) => {
    if (!navigator.clipboard) {
      throw error('ClipboardNotAvailable')
    }

    navigator.clipboard.writeText(isBase64 ? atob(text) : text)
  },
})
